const ERRORS = {
  InvalidPasswordException: 'Password must be longer than 10 characters',
  UserNotFoundException: 'Incorrect username or password',
  NotAuthorizedException: 'Incorrect username or password',
};

export { ERRORS };
